// @ts-strict-ignore
import { Middleware } from 'redux'
import { createLogger } from 'redux-logger'

const __DEV__ = import.meta.env.MODE === 'development'

export const loggerMiddleware: Middleware = createLogger({
	predicate: () => __DEV__,
})

export function logErrorToSentry(error: Error | string) {
	if (__DEV__) {
		return
	}
	console.log('logErrorToSentry', error)
}

export function webHostToEnvironment() {
	switch (import.meta.env.VITE_WEB_HOST) {
		case 'stqry.app':
			return 'production' as const
		case 'mytours.app':
			return 'staging' as const
		default:
			return 'development' as const
	}
}
